__turbopack_context__.v({
  "animatedHeader": "header-module-scss-module__Tn_vhG__animatedHeader",
  "burger": "header-module-scss-module__Tn_vhG__burger",
  "closeMenuButton": "header-module-scss-module__Tn_vhG__closeMenuButton",
  "divider": "header-module-scss-module__Tn_vhG__divider",
  "header": "header-module-scss-module__Tn_vhG__header",
  "headerActions": "header-module-scss-module__Tn_vhG__headerActions",
  "headerContainer": "header-module-scss-module__Tn_vhG__headerContainer",
  "headerFixed": "header-module-scss-module__Tn_vhG__headerFixed",
  "headerMenu": "header-module-scss-module__Tn_vhG__headerMenu",
  "headerOverlay": "header-module-scss-module__Tn_vhG__headerOverlay",
  "headerUserActions": "header-module-scss-module__Tn_vhG__headerUserActions",
  "headerWrp": "header-module-scss-module__Tn_vhG__headerWrp",
  "isHeaderHidden": "header-module-scss-module__Tn_vhG__isHeaderHidden",
  "isMenuLinkActive": "header-module-scss-module__Tn_vhG__isMenuLinkActive",
  "logo": "header-module-scss-module__Tn_vhG__logo",
  "logoImage": "header-module-scss-module__Tn_vhG__logoImage",
  "menu": "header-module-scss-module__Tn_vhG__menu",
  "menuButton": "header-module-scss-module__Tn_vhG__menuButton",
  "menuCustomButton": "header-module-scss-module__Tn_vhG__menuCustomButton",
  "menuLink": "header-module-scss-module__Tn_vhG__menuLink",
  "menuLoginButton": "header-module-scss-module__Tn_vhG__menuLoginButton",
  "menuOpened": "header-module-scss-module__Tn_vhG__menuOpened",
  "mobileActionsWrp": "header-module-scss-module__Tn_vhG__mobileActionsWrp",
  "mobileHeaderMenu": "header-module-scss-module__Tn_vhG__mobileHeaderMenu",
  "mobileMenu": "header-module-scss-module__Tn_vhG__mobileMenu",
  "wideMenuContainer": "header-module-scss-module__Tn_vhG__wideMenuContainer",
  "wideMenuMobile": "header-module-scss-module__Tn_vhG__wideMenuMobile",
});
